<header id="sidebar-toggler" class="h-16 w-full px-4 border-b border-b-slate-200/80 bg-slate-50/60 flex justify-between items-center dark:bg-gray-900 dark:border-b-white/30 group" [ngClass]="{'lg:justify-end': !hideSidebar() || isLogged()}">
  @if (!hideSidebar()) {
    <button class="z-30 flex flex-col gap-y-1 items-center lg:hidden" (click)="openSidebar.emit()">
      <span class="h-0.5 w-5.5 block bg-gray-700 rounded-sm dark:bg-gray-400 dark:group-hover:bg-white"></span>
      <span class="h-0.5 w-5.5 block bg-gray-700 rounded-sm dark:bg-gray-400 dark:group-hover:bg-white"></span>
      <span class="h-0.5 w-5.5 block bg-gray-700 rounded-sm dark:bg-gray-400 dark:group-hover:bg-white"></span>
    </button>
  } @else {
    <a routerLink="/">
      <svg xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 185 50"
           fill="none"
           role="img"
           aria-labelledby="logoTitle"
           class="h-10 w-auto cursor-pointer"
           preserveAspectRatio="xMinYMid meet">
        <title id="logoTitle">Blinth Logo</title>

        <rect x="2" y="5" width="40" height="40" rx="10" fill="#4F46E5"/>

        <path d="M12 25H32M12 18H28M12 32H22"
              stroke="white"
              stroke-width="3"
              stroke-linecap="round"/>

        <text x="50" y="25"
              font-family="Inter, system-ui, sans-serif"
              font-weight="900"
              font-size="28"
              letter-spacing="-0.03em"
              dominant-baseline="central"
              class="fill-slate-900 dark:fill-white">
          BLINTH<tspan fill="#4F46E5" dominant-baseline="central">.</tspan>
        </text>
      </svg>
    </a>
  }

  @if (!environment.app) {
    @if (isLogged()) {
      <div id="profile-icon"
           class='w-9 h-9 rounded-full bg-center bg-cover relative cursor-pointer border border-slate-200/80 dark:border-white/20 flex items-center justify-center bg-white shadow-xs dark:bg-white/5'
           [style.background-image]="user()?.user?.photoUrl ? ('url(' + (environment.s3BaseUrl + user()?.user?.photoUrl) + ')') : 'none'"
           (click)="showProfileMenu = !showProfileMenu">

        @if (!user()?.user?.photoUrl) {
          <span class="text-xs font-bold text-gray-600 dark:text-gray-300 uppercase tracking-tighter">
          {{ user()?.user?.name?.[0] }}{{ user()?.user?.surname?.[0] }}
        </span>
        }

        <div class="absolute right-0 -bottom-[250%] bg-white border border-slate-200/80 shadow-lg shadow-slate-900/5 rounded-md py-2 transition-all transition-discrete dark:bg-gray-800 dark:border-white/20 z-50"
             [ngClass]="{'hidden opacity-0': !showProfileMenu, 'block': showProfileMenu}">
          <a routerLink="/profilo/generale" class="py-1 px-3 text-nowrap text-gray-900 font-medium flex items-center hover:bg-slate-50 dark:hover:bg-white/5 dark:text-white">Il mio profilo</a>
          <button class="w-full py-1 px-3 text-gray-900 font-medium flex items-center cursor-pointer hover:bg-slate-50 dark:hover:bg-white/5 dark:text-white" (click)="logout()">
            Logout <i class="fa-solid fa-arrow-right text-xs ml-1.5 pt-1"></i>
          </button>
        </div>
      </div>
    } @else {
      <div class="flex items-center gap-x-6 text-gray-700 font-semibold dark:text-white">
        <a routerLink="/auth/login">Login</a>
        <a routerLink="/auth/registrazione" class="bg-indigo-500 py-1 px-3 rounded-md text-base font-semibold text-white cursor-pointer hover:bg-indigo-400">Registrati</a>
      </div>
    }
  }
</header>
